<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <Card>
                <div class="row mb-4">
                    <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Load removal') }}</h5>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Time of removal') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <DateTimePicker
                                    :placeholder="__('Select date and time')"
                                    format="YYYY-MM-DD HH:mm"
                                    name="removal_time"
                                    type="datetime"
                                    v-model="load.time"
                                    v-validate="'required'"
                                    value-type="format"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Status') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    :value="load.status"
                                    disabled
                                    name="removal_status"
                                    type="text"
                                ></FormInput>
                            </div>

                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Driver') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="load.driver"
                                    :fetch-callback="[{name: 'Petras'},{name: 'Jonas'}]"
                                    :placeholder="__('Select driver')"
                                    :value="load.driver"
                                    @selected="(item) => load.driver = item.name"
                                    name="removal_driver"
                                    params="name"
                                    v-validate="'required'"
                                    value-selector="name"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.name }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Transport type') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    name="removal_transport_type"
                                    type="text"
                                    v-model="load.transportType"
                                    v-validate="'required'"
                                ></FormInput>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Sender') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="load.sender"
                                    :fetch-callback="[{name: 'Ona'},{name: 'Rasa'}]"
                                    :placeholder="__('Select sender')"
                                    :value="load.sender"
                                    @selected="(item) => load.sender = item.name"
                                    name="removal_sender"
                                    params="name"
                                    v-validate="'required'"
                                    value-selector="name"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.name }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Transport identification No') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    name="removal_transport_id"
                                    type="text"
                                    v-model="load.transportId"
                                    v-validate="'required'"
                                ></FormInput>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12">&nbsp;</div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Recipient') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <Autocomplete
                                    :data="load.recipient"
                                    :fetch-callback="[{name: 'Zuvelita'},{name: 'Piene'}]"
                                    :placeholder="__('Select recipient')"
                                    :value="load.sender"
                                    @selected="(item) => load.recipient = item.name"
                                    name="removal_recipient"
                                    params="name"
                                    v-validate="'required'"
                                    value-selector="name"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.name }}
                                    </div>
                                </Autocomplete>
                            </div>
                        </div>
                    </div>

                    <div class="hidden-sm col-md-2"></div>

                    <div class="col-sm-12 col-md-5">
                        <div class="row">
                            <div class="col-sm-12 col-md-5">
                                {{ __('Recipient address') }}
                            </div>
                            <div class="col-sm-12 col-md-7">
                                <FormInput
                                    name="removal_recipient_address"
                                    type="text"
                                    v-model="load.recipientAddress"
                                    v-validate="'required'"
                                ></FormInput>
                            </div>
                        </div>
                    </div>
                </div>

                <ShipmentsForm :shipments="load.shipments" :typeLoad="true"/>
            </Card>
            <br/>
            <div class="row">
                <div class="col-sm-6 col-md-6">
                    <button
                        @click="confirmLoad"
                        class="btn btn-sm btn-cyan btn-seperate col-sm-6 col-md-4"
                        v-if="load.id"
                    >
                        {{ __('Confirm') }}
                    </button>

                    <button
                        class="btn btn-sm btn-cyan col-sm-6 col-md-4"
                        v-if="load.id"
                    >
                        {{ __('Way bill') }}
                    </button>
                </div>

                <div class="col-sm-6 col-md-6 text-right">
                    <RequestButton
                        :on-click="saveLoad"
                        class="btn btn-sm btn-primary btn-seperate col-sm-6 col-md-4"
                    >
                        {{ __('Save') }}
                    </RequestButton>

                    <button
                        @click="cancel"
                        class="btn btn-sm btn-red col-sm-6 col-md-4"
                    >
                        {{ __('Cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Shipment from '../../models/Shipment'
import RequestButton from '../../plugins/RequestButton'
import { $api } from '../../services/api'
import { __ } from '../../translations/localization'
import ShipmentsForm from '../Releases/ShipmentsForm'

export default {
  name: 'LoadRemoval',

  components: { ShipmentsForm, RequestButton },

  beforeRouteEnter (to, from, next) {
    if (!to.params.id) {
      next((vm) => {
        vm.$nextTick(() => vm.$validator.reset())
        vm.load = new Shipment({ status: `${__('unconfirmed')}` })
      })
    }

    $api.shipments.show(to.params.id).then((load) => {
      next((vm) => {
        vm.load = new Shipment(load)
      })
    })
  },

  data () {
    return {
      load: new Shipment({})
    }
  },

  methods: {
    confirmLoad () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          return this.$api.shipments.update(this.load.id, this.load, this.status = 'confirmed')
            .then(() => {
              this.$toaster.success(__('The load was successfully confirmed!'))
              this.$router.push('/shipments')
            })
        }
      })
    },

    saveLoad () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.load.id) {
            return this.$api.shipments.update(this.load.id, this.load)
              .then(() => {
                this.$toaster.success(__('The load was successfully updated!'))
                this.$router.push('/shipments')
              })
          }

          return this.$api.shipments.create(this.load)
            .then(() => {
              this.$toaster.success(__('The load was successfully created!'))
              this.$router.push('/shipments')
            })
        }
      })
    },

    cancel () {
      this.$modal.confirm(
        __('Are you sure want to cancel?'),
        () => {
          this.$router.push('/')
        }
      )
    }
  }
}
</script>
